import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');
export default function CardmsgC({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div
            className={`${css.cardmsgC} cardmsgC3 GtmModuleData-section`}
            data-section-id={css.cardmsgC}
            data-section-title={t('portability')}
            style={{ height: '5.4rem' }}
        >
            <div className="card-msgs">
                <div className="card-title">{t('portability')}</div>
                <div className="card-desc">{t('portability_desc')}</div>
            </div>
            <div className="card-img" style={{ height: '5.4rem' }}>
                <EFPic name={[`InteriorDesign3.webp`, `InteriorDesign3.png`]} className="fullImgs" alt={t('portability')} />
            </div>
        </div>
    );
}
